(function ($) {

    const initializeBlock = function ($block) {
      var $blockContent = $block.find('.scrollingFleet-content .contentStyled')
      var blockContentHeight = $blockContent.outerHeight()
      var viewHeight = window.innerHeight / 2
      var calculation = viewHeight - (blockContentHeight / 2)

      $blockContent.css('top', calculation);
    }

    $(document).ready(function () {
        $('.block--scrolling-fleet').each(function () {
            initializeBlock($(this));
        })
    })

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=scrolling-fleet', initializeBlock);
    }

})(jQuery);
